/** @format */
import React from 'react';
import { PageContainer, TabListFp } from 'components';
import { useStyles } from './style';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { Tab } from '@mui/material';
import AllRequests from './AllRequests';
import AsServiceSet from './ReportUsed';
import useCustomHook from './hooks';
import { getDynamicObjectAction , constBreadCrumbsTitle } from 'utility';

const ReportUsed = () => {
  const classes = useStyles();
  const { activeTab, setActiveTab } = useCustomHook();
  const actionsList =
    getDynamicObjectAction([
      'requestListPage',
    ])
  
  const hint = 'در این صفحه لیست سرویس‌هایی که در سایت پادیوم درخواست داده‌اید، را مشاهده کنید.';

  return (
    <PageContainer
      title="لیست درخواست‌های ارسالی"
      description={hint}
      pageKey="sentRequests"
      breadcrumbs={constBreadCrumbsTitle.REQUEST_WEBSERVICES}
    >
      {actionsList['requestListPage'] && (
        <TabContext value={activeTab}>
          <TabListFp
            style={{ marginTop: -15 }}
            onChange={(e, v) => setActiveTab(v)}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="به تفکیک مجموعه سرویس" value="1" />
            <Tab label="همه درخواست‌ها" value="2" />
          </TabListFp>

          <TabPanel value="1" className={classes.tabPanel}>
            <AsServiceSet />
          </TabPanel>
          <TabPanel value="2" className={classes.tabPanel}>
            <AllRequests />
          </TabPanel>
        </TabContext>
      )}
    </PageContainer>
  );
};

export default ReportUsed;
